import React from 'react';

const ArcOne = ({
  fill = 'white',
  stroke = 'rgba(240, 0, 55, 0.06)',
  strokeWidth = 1,
  className = '',
}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="87"
        height="128"
        viewBox="0 0 87 128"
        fill="none"
        className={className}
        
      >
        <path
          d="M37.1795 126.796C33.3381 128.467 28.8557 127.962 25.6973 125.21C15.2695 116.124 7.86097 105.978 3.88205 95.2901C-0.736063 82.8859 -0.623457 70.0497 4.21205 57.673C9.04756 45.2964 18.49 33.6761 31.8837 23.6192C44.0439 14.4884 59.1964 6.84506 76.4563 1.11809C79.6881 0.0457333 83.2289 1.04512 85.513 3.57045C87.6823 5.96871 86.6154 9.81737 83.5584 10.8719C69.1754 15.8332 56.5217 22.3244 46.2801 30.0146C34.4937 38.8647 26.1843 49.0906 21.929 59.982C17.6738 70.8734 17.5747 82.1693 21.6386 93.085C24.8439 101.694 30.5783 109.905 38.5647 117.365C41.5274 120.133 40.8974 125.179 37.1795 126.796Z"
          fill={fill}
          stroke={stroke}
          style={{
            mixBlendMode: 'multiply',
            filter: 'blur(1px)',
          }}
        />
        <path
          d="M76.6133 1.59222C79.5548 0.616207 82.7774 1.46527 84.9365 3.68695L85.1426 3.9057C87.0007 5.96008 86.1837 9.24278 83.6465 10.3032L83.3955 10.3989C69.423 15.2186 57.0655 21.4823 46.9512 28.894L45.9795 29.6147C34.138 38.5062 25.7597 48.8023 21.4629 59.8002C17.2977 70.4615 17.0731 81.5147 20.7969 92.2241L21.1699 93.2592C24.3059 101.682 29.8321 109.71 37.4766 117.025L38.2236 117.731C40.8668 120.2 40.3676 124.594 37.2861 126.192L36.9805 126.338C33.4142 127.89 29.2917 127.475 26.3105 125.072L26.0254 124.832C15.9712 116.072 8.75729 106.338 4.73047 96.1069L4.35059 95.1157C-0.0814534 83.2112 -0.115596 70.9119 4.24219 59.0063L4.67773 57.8549C9.32184 45.9682 18.2642 34.7571 30.9453 24.9623L32.1836 24.019C43.9145 15.2105 58.4544 7.78398 75.0059 2.13422L76.6133 1.59222Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeOpacity="0.06"
        />
      </svg>
    </>
  );
};

export default ArcOne;
